import {
    GET_ALL_RT_INVOICING_ENTITY,
    SET_ALL_RT_INVOICING_ENTITY,
    POST_RT_INVOICING_ENTITY,
    PUT_RT_INVOICING_ENTITY,
    DELETE_RT_INVOICING_ENTITY
} from '../../constants';
import { errorNotification, successNotification } from "../../../../utils/notification";
import { FINANCIAL_RT_ENDPOINT } from '../../constants/endpoint';
import { onSuccess, onError } from '../../../../utils/http';

export const getAllInvoicingEntity = () => {
    return {
        type: GET_ALL_RT_INVOICING_ENTITY,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoicingEntity`
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                store.dispatch(setAllInvoicingEntity(response.data));
                return response;
            })
        }
    };
};

export const setAllInvoicingEntity = (data) => {
    return {
        type: SET_ALL_RT_INVOICING_ENTITY,
        payload: data
    };
};

export const postInvoicingEntity = (invoicingEntity) => {
    return {
        type: POST_RT_INVOICING_ENTITY,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoicingEntity`,
            method: 'post',
            data: invoicingEntity
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "create_success");
                store.dispatch(getAllInvoicingEntity());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "create_error");
                throw error;
            })
        }
    };
};

export const putInvoicingEntity = (id, invoicingEntity) => {
    return {
        type: PUT_RT_INVOICING_ENTITY,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoicingEntity/${id}`,
            method: 'put',
            data: invoicingEntity
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "update_success");
                store.dispatch(getAllInvoicingEntity());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "update_error");
                throw error;
            })
        }
    };
};

export const deleteInvoicingEntity = (id) => {
    return {
        type: DELETE_RT_INVOICING_ENTITY,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/invoicingEntity/${id}`,
            method: 'delete'
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "delete_success");
                store.dispatch(getAllInvoicingEntity());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', error.response.status === 409 ? "ressource_in_use_error" : "delete_error");
                throw error;
            })
        }
    };
};